import { ReactNode } from "react";

const ActionsWrapper = ({ children }: { children: ReactNode }) => {
    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
            }}
            className={`absolute inset-0 z-10 h-full bg-gradient-to-r from-transparent from-0% to-primary-finance3 to-15% pl-4 pr-2.5 opacity-0 transition-opacity duration-200 ease-in-out group-hover:opacity-100`}
        >
            <div className="flex h-full items-center justify-end gap-2">
                {children}
            </div>
        </div>
    );
};

export default ActionsWrapper;
